<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">구매 목록</h3>
      </v-toolbar>

      <v-flex xs12 class="mt-2" v-if="purchases.length">
        <v-card v-for="(product, index) of purchases" :key="index"
                @click="onClickProduct({ idx: product.store.idx, lectureIdx: product.start_lecture_idx  })"
                tile flat class="card-shadow px-3 pb-2 mb-2" style="padding-top: 18px;">

          <v-layout row class="mb-3">
            <v-flex style="flex-grow: 0; flex-shrink: 0;">
              <v-img width="64px"
                     :aspect-ratio="16/9"
                     :src="product.store.thumbnail ? `${$storage}/store/${product.store.thumbnail}` : thumbnailSrc">
              </v-img>
            </v-flex>

            <v-flex class="ml-2">
              <div class="text-xs-left">{{ product.store.title }}</div>
              <v-layout row align-center class="mt-2">
                <div class="d-flex align-center" style="color: black; font-size: 12px;">
                  <span>{{ addComma(product.payment.amount) }}원</span>
<!--                  <v-divider vertical class="mx-2" style="align-self: auto; min-height: 0; height: 9px; border-color: black;"></v-divider>-->
<!--                  <span>{{ statusText(product.payment.status) }}</span>-->
<!--                  &lt;!&ndash; TODO 진행중 표시 뭘로 구별하더라 &ndash;&gt;-->
                </div>
                <v-spacer></v-spacer>
                <template v-if="product.store.category_idx !== 3">
                  <span>
                    <v-img width="24px" class="mr-1"
                           :src="product.store.review_idx
                             ? require(`@/assets/img/icon-star-active.png`)
                             : require(`@/assets/img/icon-star-deactive.png`)">
                    </v-img>
                  </span>
                  <span style="color: black; font-size: 12px;">{{ product.store.review_score === 0 ? '리뷰를 작성하세요' : product.store.review_score.toFixed(1) }}</span>
                </template>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-btn depressed
                   color="#f8f8f8"
                   style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #ec2f54;"
                   class="ma-0"
                   @click.stop="$router.push({ name: 'Review', params: { storeIdx: product.store.idx, title: product.store.title, thumbnail: product.store.thumbnail } })"
                   v-if="product.payment.status !== 'ready' && product.payment.status !== 'invoice' && !product.store.review_idx">
              리뷰작성
            </v-btn>
            <v-btn depressed
                   color="#f8f8f8"
                   style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #4a4a4a;"
                   class="ma-0"
                   @click.stop="$router.push({ name: 'Review', params: { idx: product.store.review_idx, storeIdx: product.store.idx, title: product.store.title, thumbnail: product.store.thumbnail, score: product.store.review_score } })"
                   v-else-if="product.payment.status !== 'ready' && product.store.review_idx">
              리뷰확인
            </v-btn>
            <v-spacer></v-spacer>
<!--            <v-btn depressed color="#f8f8f8"-->
<!--                   style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #4a4a4a;"-->
<!--                   class="ma-0 mr-2" @click.stop>구매확정</v-btn>-->
            <v-btn v-if="product.payment.status === 'invoice'"
                   depressed color="#f8f8f8"
                   style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #4a4a4a;"
                   class="ma-0" @click.stop="invoicePay(product.store.title, product.payment.note_url, product.payment.amount, product.store.idx, product.idx)">결제</v-btn>
            <v-btn v-else-if="product.payment.status === 'paid'"
                   flat style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #4a4a4a;"
                   :ripple="false" class="ma-0">결제완료</v-btn>
            <v-btn v-else
                   depressed color="#f8f8f8"
                   style="font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #4a4a4a;"
                   class="ma-0" @click.stop="cancel(product.payment.status, product.payment.idx)">{{ cancelText(product.payment.status) }}</v-btn>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex v-else>
        <div style="color: #9b9b9b;" class="my-5">
          <div class="mb-3">아직 구매한 상품이 없습니다.</div>
        </div>
        <v-img :src="require('@/assets/img/cart.png')" width="120px" style="margin: auto;"></v-img>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { intToCommaString } from '@/util/util';

  export default {
    name: 'Purchases',
    computed: {
      ...mapGetters('product', [ 'purchases' ]),
      thumbnailSrc () {
        return require('@/assets/img/thumbnail-default.png');
      },
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        scrollY: 0,
        page: 1,
        bottom: true,
      };
    },
    beforeRouteLeave (to, from, next) {
      if (!to.name || to.name === 'PaymentComplete') {
        next({
          name: 'More',
          replace: true,
        });
      } else {
        next();
      }
    },
    created () {
      this.selectPurchases({ second: this.time, page: this.page }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectPurchases({ second: this.time, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapActions('product', [ 'selectPurchases' ]),
      onClickProduct ({ idx, lectureIdx }) {
        console.log(`onclick ${idx} ${lectureIdx}`);
        if (lectureIdx) {
          this.$router.push({ name: 'Lecture', params: { idx, lectureIdx  } });
        }
      },
      getScrollY () {
        this.scrollY = window.scrollY;
        this.bottomVisible();
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
      statusText (status) {
        switch (status) {
          case 'ready':
            return '런칭 전';
          // case 'normal':
          //   return this.$t('confirmBtn.confirm');
          case 'start':
            return '시작하기';
          case 'watching':
            return '이어보기';
          case 'expired':
            return '기간만료';
          case 'invoice':
            return '결제 대기중';
          case 'paid':
            return '결제완료';
          default:
            return '';
        }
      },
      cancel (status, paymentIdx) {
        if (status ==='ready') {
          // TODO: tid 확인
          this.$router.push({ name: 'RefundRequest', params: { paymentIdx } });
        } else {
          // eslint-disable-next-line
          Kakao.PlusFriend.chat({
            plusFriendId: '_ygxjIT'
          });
        }
      },
      invoicePay (title, invoice, amount, idx, paymentIdx) {
        this.$router.push({ name: 'InvoicePayment', params: { title, invoice, amount: parseInt(amount), idx, paymentIdx } });
      },
      cancelText (status) {
        if (status === 'ready') return '구매취소';
        else return '문의하기';
      },
      addComma (int) {
        return intToCommaString(int);
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

</style>
